module.exports = __webpack_public_path__ + "images/img-1udSRja.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/managers/81.jpg
// module id = 2024
// module chunks = 0